import {useRef} from "react";

/**
 * A custom hook that generates unique sequential IDs starting from a given number.
 */
export function useIDGenerator(start: number = 0) {
  const counter = useRef(start);

  /**
   * Generates the next unique identifier by incrementing the current counter value and returning it.
   */
  function nextID(): number {
    counter.current += 1;
    return counter.current;
  }

  /**
   * Resets the counter's current ID to its initial start value and returns it.
   */
  function resetID(): number {
    counter.current = start;
    return counter.current;
  }

  return {nextID, resetID};
}
